//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionAttachment(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.01008 21C8.29008 21 9.57008 20.51 10.5501 19.54L21.1201 8.96C22.2901 7.79 22.2901 5.89 21.1201 4.72C19.9501 3.55 18.0501 3.55 16.8801 4.72L6.31008 15.29L7.72008 16.7L18.3001 6.13C18.6901 5.74 19.3201 5.74 19.7101 6.13C20.1001 6.52 20.1001 7.15 19.7101 7.54L9.13008 18.12C7.96008 19.29 6.06008 19.29 4.89008 18.12C3.72008 16.95 3.72008 15.05 4.89008 13.88L13.3801 5.4L11.9701 3.99L3.48008 12.47C1.53008 14.42 1.53008 17.59 3.48008 19.54C4.45008 20.51 5.73008 21 7.01008 21Z" fill="currentColor" /></svg>;
}
export default IconActionAttachment;